import { render } from "./editZizhanghao.vue?vue&type=template&id=386f3111&scoped=true"
import script from "./editZizhanghao.vue?vue&type=script&lang=js"
export * from "./editZizhanghao.vue?vue&type=script&lang=js"

import "./editZizhanghao.vue?vue&type=style&index=0&id=386f3111&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386f3111"]])

export default __exports__